package fr.manyverse.app.presentation.components.premade

import fr.manyverse.app.domain.model.ImageData
import fr.manyverse.app.domain.model.ItemCategory
import fr.manyverse.app.domain.model.PreMadeInventoryItem

/**
 * Brouillon d'un objet de départ d'un pré-tiré, manipulé dans la popup de création/édition
 * ([fr.manyverse.app.presentation.components.gm_screen.PreMadeCharacterFormDialog]) avant sa
 * persistance. L'image n'est réellement uploadée/copiée qu'à la sauvegarde du pré-tiré.
 *
 * Sources d'image mutuellement exclusives :
 * - [newImage] : fichier local choisi par le MJ (création ou remplacement) ;
 * - [copyFromPath] : chemin storage d'un objet du coffre MJ à recopier (import) ;
 * - [removeImage] : suppression de l'image existante ;
 * - sinon [existingImageUrl] est conservé tel quel.
 */
data class PreMadeItemDraft(
    val id: String,
    val name: String,
    val category: ItemCategory,
    val quantity: Int,
    val existingImageUrl: String? = null,
    val existingSignedUrl: String? = null,
    val newImage: ImageData? = null,
    val copyFromPath: String? = null,
    val removeImage: Boolean = false,
)

/** Vignette à afficher (image locale non encore uploadée en priorité, sinon URL signée existante). */
val PreMadeItemDraft.displaySignedUrl: String?
    get() = if (newImage == null && !removeImage) existingSignedUrl else null

fun PreMadeInventoryItem.toDraft() = PreMadeItemDraft(
    id = id,
    name = name,
    category = category,
    quantity = quantity,
    existingImageUrl = imageUrl,
    existingSignedUrl = signedImageUrl,
)
